import React, { FC } from 'react';
import _ from 'lodash';
import { getIn } from 'formik';
export interface Props {
  touched: boolean | undefined;
  error: string | undefined;
  name?: string | undefined;
}

const Feedback: FC<Props> = ({ touched, error, name }: Props) => {
  if (touched && !!error) {
    let errorMessage = error;
    if (_.isArray(error)) {
      errorMessage = error[0];
      errorMessage = getIn(errorMessage, name || '');
    } else if (_.isObject(error)) {
      return null;
    }

    return (
      <div className="feedback-invalid" data-testid="feedback-invalid">
        {errorMessage}
      </div>
    );
  }
  return null;
};

export default Feedback;
